
export class AdsModel {
          mkmId!: any;
          adType!: Number;
          fileContent!: string;
          fileName!: string;
          adUrl!: string;
          fileType!: string;
          adTitle!:string;
          type!:string;
          startDate!:string;
          endDate!:string;
      }